<template>
    <div>
        <div id="slider" v-for="(config, index) in configs" :key="index" >
            <router-link class="col-3 area" :to="{name: 'cursos'}">
                <img :src="'https://univitoriaead.com.br/admin/public/storage/'+config.slider" alt="" width="100%">
            </router-link>
        </div>
        <div class="areas">
            <div class="container">
                <div class="row areas">
                    <router-link class="col-3 area" :to="{name: 'categoria', params: {catID: '1'}}">
                        <img src="@/assets/images/icons/educacao.png" alt="" width="100%">
                        EDUCAÇÃO
                    </router-link>
                    <router-link class="col-3 area" :to="{name: 'categoria', params: {catID: '7'}}">
                        <img src="@/assets/images/icons/empresarial.png" alt="" width="100%">
                        EMPRESARIAL
                    </router-link>
                    <router-link class="col-3 area" :to="{name: 'categoria', params: {catID: '19'}}">
                        <img src="@/assets/images/icons/engenharia.png" alt="" width="100%">
                        ENGENHARIA
                    </router-link>
                    <router-link class="col-3 area" :to="{name: 'categoria', params: {catID: '21'}}">
                        <img src="@/assets/images/icons/estetica.png" alt="" width="100%">
                        ESTÉTICA
                    </router-link>
                    <router-link class="col-3 area" :to="{name: 'categoria', params: {catID: '5'}}">
                        <img src="@/assets/images/icons/juridico.png" alt="" width="100%">
                        JURÍRICO
                    </router-link>
                    <router-link class="col-3 area" :to="{name: 'categoria', params: {catID: '27'}}">
                        <img src="@/assets/images/icons/mba.png" alt="" width="100%">
                        MBA                        
                    </router-link>
                    <router-link class="col-3 area" :to="{name: 'categoria', params: {catID: '29'}}">
                        <img src="@/assets/images/icons/saude.png" alt="" width="100%">
                        SAÚDE
                    </router-link>
                    <router-link class="col-3 area" :to="{name: 'categoria', params: {catID: '31'}}">
                        <img src="@/assets/images/icons/social.png" alt="" width="100%">
                        SERVIÇO SOCIAL
                    </router-link>
                    <a href="/cursos/pos-graduacao" class="btn btn-primary">VEJA MAIS</a>
                </div>
            </div>
        </div>
        <div class="section wb">
                <div class="row align-items-center about">
                    <div class="col-md-6">
                        <img src="@/assets/images/about_02.jpg" class="img_about" width="70%">
                    </div><!-- end col -->
                    <div class="col-md-6">
                        <div class="message-box">
                            <div class="row">
                                <div class="col-12 text-center mb-4"><h2>Motivos para estudar na UniVitória</h2></div>
                            
                                <div class="col-6">
                                    <h4>100% Online</h4>
                                    <p>Todos os cursos de Pós Graduação são 100% online dando ao aluno a possibilidade de estudar onde e quando quiser.</p>
                                </div>
                                <div class="col-6">
                                    <h4>Reconhecido pelo MEC</h4>
                                    <p>Todos os cursos de Pós Graduação da UniVitória são reconhecidos pelo MEC</p>
                                </div>

                                <div class="col-6">
                                    <h4>TCC opcional</h4>
                                    <p>Nos cursos de Pós Graduação da UniVitória o TCC é opcional, seguindo os parametros e diretrizes do MEC</p>
                                </div>
                                <div class="col-6">
                                    <h4>Conclusão rápida</h4>
                                    <p>Conclua seu curso de Pós Graduação a partir de 4 meses e se torne um especialista se destacando no mercado.</p>
                                </div>
                            </div>
                            <a class="btn btn-danger" :href="'https://api.whatsapp.com/send?phone=27981114702'" target="_blank">
                                QUERO SABER MAIS
                            </a>
                        </div><!-- end messagebox -->
                    </div><!-- end col -->
                </div>
                <div class="container contact">
                    <div class="row">
                        <div class="col-6">
                            <h2>Ainda tem dúvidas?</h2>
                            <p>Clique no botão ao lado e entre em contato com nossos consultores</p>
                        </div>
                        <div class="col-6 text-center" v-for="(config, index) in configs" :key="index">
                            <a v-if="config.celular" :href="'https://api.whatsapp.com/send?phone='+config.celular" target="_blank">
                                <img src="https://images.tcdn.com.br/static_inst/integracao/imagens/whatsapp.png">
                            </a>
                            <a href="mailto:contato@univitoriaead.com.br" target="_blank">
                                <img src="https://images.vexels.com/media/users/3/140138/isolated/lists/88e50689fa3280c748d000aaf0bad480-icone-redondo-de-email-1.png" width="12%">
                            </a>
                        </div>
                    </div>
                </div>
        </div><!-- end section -->
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    mounted() {
        this.getPage('quemsomos')
            .catch(response => this.$vToastify.error('Falha ao carregar institucional', 'Erro'))
    },

    computed: {
        ...mapState({
            page: state => state.page.items,
        }),
        ...mapState({
            configs: state => state.configs.items
        })
    },

    methods: {
        ...mapActions([
            'getPage',
        ]),
    }
}
</script>

<style>
.areas{
    margin-top: 30px;
}
.areas .area{
    display: block;
    text-align: center;
    padding: 10px 5px;
    background: #EEE;
    border: 5px solid #FFF;
    cursor: pointer;
}
.areas .area:hover{
    background: #DDD;
    color:#000;
   
}
.areas a{
    margin: 0 auto;
}
.about{
    padding: 20px;
    background: url('../assets/images/bg.jpg');
}
.img_about{
    float: right;
    border: 3px solid #000;
}
.message-box h2{
    text-transform: uppercase;
    padding: 0;
    margin: 0 0 5px;
    font-weight: 600;
    letter-spacing: 0.5px;
    font-size: 18px;
    color: #000;
}
.message-box a{
    margin: 0 auto;
    display: block;
    width: 50%;
}
.contact{
    background: #EEE;
    border-radius: 10px;
    padding: 20px;
}
</style>